export enum ViewType {
  GRAPH = 'graph',
  GRAPH_VIEWS = 'graph_views',
  MAP = 'map',
  TABLE = 'table',
  CI_HEALTH = 'ci_health',
}

export enum GRAPH_MODE {
  SCHEMA = 'schema',
  MONITORING = 'monitoring',
}

/**
 * Soft cache for mode queries that remount on every view switch (not keepMounted).
 * Project defaults use `cacheTime: 0` + `staleTime: Infinity` + `refetchOnMount: false`,
 * which means empty spinner on every return. These options show last data immediately
 * and refetch in the background — local UI state still resets on unmount.
 */
export const SRM_MODE_SWITCH_QUERY_OPTIONS = {
  cacheTime: 5 * 60 * 1000,
  staleTime: 0,
  refetchOnMount: true as const,
};
